import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output
} from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { HttpClient } from '@angular/common/http';
import { CustomizedLabels, PageRequest, WorkflowEvent } from '@models/models';
import { DashboardDataServiceProvider } from '@services/dashboard/dashboard.data.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import { BrandsDataServiceProvider } from '@services/brands/brands.data.service';
import { filter, takeUntil } from 'rxjs/operators';
import { SettingsProvider } from '@services/settings/settings';

@Component({
	selector: 'shoots-appointments-block',
	template: require('./shoots-appointments-block.html'),
	styles: [require('./shoots-appointments-block.scss')]
})
export class ShootsAppointmentsBlockComponent implements OnInit, OnDestroy {
	@Input() buttonDisabled: boolean;
	@Input() spinningWheelActive: boolean;
	@Output()
	chooseModalTrigger: EventEmitter<WorkflowEvent> = new EventEmitter<
		WorkflowEvent
	>();
	unsubscribe: Subject<void> = new Subject();

	data: WorkflowEvent[] = [];
	flatData: WorkflowEvent[] = [];
	itemsQuantity: number;
	pagesQuantity: number;
	pageRequest: PageRequest;
	shootsLabelName: string;

	readonly PAGE_REQUEST_DEFAULT: PageRequest = {
		filterBy: 'upcoming',
		paging: {
			pageNumber: 0,
			pageSize: 12,
			searchToken: null
		},
		sortCriterias: [
			{
				fieldName: 'startDate',
				sortAscending: true
			},

			{
				fieldName: 'startTime',
				sortAscending: true
			}
		]
	};

	constructor(
		private http: HttpClient,
		private dashboardDataService: DashboardDataServiceProvider,
		private brandsDataService: BrandsDataServiceProvider,
		private messageService: MessageService,
		private settingsService: SettingsProvider
	) {}

	ngOnInit(): void {
		this.pageRequest = this.PAGE_REQUEST_DEFAULT;
		this.subscribeToCustomizeLabelsChange();
		this.configureCommunicationAdapter();
		this.subscribeToBrandsChange();
		this.getData();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	addNew(): void {
		$('#addNewModal').modal('show');
	}

	showEvent(event, $event): void {
		if ($event && $event.stopPropagation) {
			$event.stopPropagation();
		}

		if (
			event &&
			(this.isJob(event) ||
				(this.isAppointment(event) && event.jobId) ||
				this.isExtrashoot(event))
		) {
			return;
		}

		this.chooseModalTrigger.emit(event);
	}

	updateData(pageRequest: PageRequest): void {
		this.pageRequest = pageRequest;
		this.dashboardDataService
			.getShootsAppointmentsData(pageRequest)
			.subscribe(
				(data): void => this.successGetData(data),
				(error): void => this.messageService.showDefaultErrorMessage(error)
			);
	}

	paginationToDefaults(): void {
		this.pageRequest = this.PAGE_REQUEST_DEFAULT;
		delete this.pageRequest.paging.searchToken;
		this.getData();
	}

	private subscribeToCustomizeLabelsChange(): void {
		this.settingsService.customizeLabelsObservable
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(
				(customizeLabels: CustomizedLabels): string =>
					(this.shootsLabelName = customizeLabels.shootsLabel)
			);
	}

	private getData(): void {
		this.dashboardDataService
			.getShootsAppointmentsData(this.pageRequest)
			.subscribe(
				(data): void => this.successGetData(data),
				(error): void => this.messageService.showDefaultErrorMessage(error)
			);
	}

	private subscribeToBrandsChange(): void {
		this.brandsDataService.brandsChange
			.pipe(
				takeUntil(this.unsubscribe),
				filter((data): boolean => !!data)
			)
			.subscribe((): void => this.getData());
	}

	private successGetData(data): void {
		this.pageRequest.paging.searchToken = data.searchToken;
		this.itemsQuantity = data.totalSize;
		this.pagesQuantity = Math.ceil(
			this.itemsQuantity / this.pageRequest.paging.pageSize
		);
		this.flatData = data.items;
		this.data = this.reformatData(data);
	}

	private reformatData(data) {
		const groups = data.items.reduce((groups, item) => {
			(groups[item.startDate] = groups[item.startDate] || []).push(item);
			return groups;
		}, {});

		const result = Object.keys(groups).map(k => groups[k]);
		return result;
	}

	private isJob(event): boolean {
		return event.calendarEventType === 'MAIN_SHOOT';
	}

	private isExtrashoot(event): boolean {
		return event.calendarEventType === 'EXTRA_SHOOT';
	}

	private isAppointment(event): boolean {
		return event.calendarEventType === 'APPOINTMENT';
	}

	private updateModel(resetPagination: boolean): void {
		if (resetPagination) {
			this.paginationToDefaults();
		} else {
			this.getData();
		}
	}

	private configureCommunicationAdapter(): void {
		window.snCommunicationAdapter.registerMethod(
			'updateShootsModel',
			this.updateModel.bind(this)
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/dashboard/shoots-appointments-block/shoots-appointments-block.ts